import React from 'react'
import styled from 'styled-components'

// Nimi kentän yläpuolella, kehystetty kenttä. (Vanha "kelluva" nimi skaalautui
// transform: scale(1.2):lla ja levitti lomakkeen leveämmäksi kuin sen laatikko.)

const InputLabel = styled.span`
	display: block;
	margin-bottom: 7px;
	font-size: 15px;
	font-weight: 600;
	color: ${props => props.theme.inkColor};
`

const StyledInput = styled.input`
	display: block;
	width: 100%;
	box-sizing: border-box;
	padding: 14px 16px;
	font-family: inherit;
	font-size: 17px;
	color: ${props => props.theme.inkColor};
	background: #fff;
	border: 1.5px solid ${props => props.theme.lineStrongColor};
	border-radius: ${props => props.theme.radius};
	outline: none;
	transition: border-color 0.15s ease, box-shadow 0.15s ease;
	&::placeholder {
		color: #98a3ab;
	}
	&:hover {
		border-color: ${props => props.theme.primaryColor};
	}
	&:focus {
		border-color: ${props => props.theme.primaryColor};
		box-shadow: 0 0 0 3px rgba(1, 72, 124, 0.15);
	}
	&[readonly] {
		background: ${props => props.theme.softColor};
		border-color: ${props => props.theme.lineColor};
		cursor: default;
		box-shadow: none;
	}
`

const InputWrapper = styled.label`
	display: block;
	margin-bottom: 4px;
	&.error ${StyledInput} {
		border-color: ${props => props.theme.errorColor};
	}
`

const Error = styled.div`
	min-height: 22px;
	padding-top: 4px;
	font-size: 14px;
	color: ${props => props.theme.errorColor};
`

const Input = ({
	name,
	label,
	type,
	error,
	placeholder,
	value,
	onChange,
	onFocus,
	onBlur,
	ref,
}) => {
	const [fieldValue, setFieldValue] = React.useState('')

	const handleChange = e => {
		if (typeof onChange === 'function') {
			onChange({
				target: {
					value: e.target.value,
					name: name,
				},
			})
			return
		}
		setFieldValue(e.target.value)
	}

	const val = value || fieldValue
	// Ilman onChange-käsittelijää annettua arvoa ei voi muuttaa (esim. Y-tunnus),
	// joten se näytetään lukukenttänä.
	const readOnly = typeof onChange !== 'function' && !!value

	return (
		<InputWrapper className={error ? 'error' : ''}>
			<InputLabel>{label}</InputLabel>
			<StyledInput
				name={name}
				type={type}
				value={val || ''}
				placeholder={placeholder}
				onChange={handleChange}
				onFocus={onFocus}
				onBlur={onBlur}
				readOnly={readOnly}
				ref={ref}
			/>
			<Error>{error}</Error>
		</InputWrapper>
	)
}

export default Input
